import { render, staticRenderFns } from "./RegisteredMessage.vue?vue&type=template&id=2d7a856b"
import script from "./RegisteredMessage.vue?vue&type=script&lang=js"
export * from "./RegisteredMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports